/*
This file is autogenerated. Don't change it directly.
Instead, change the "addons" setting in your package.json file.
*/

const projectConfigLoader = require('@root/config');
import voltoDropdownmenu from 'volto-dropdownmenu';
import voltoVenue from 'volto-venue';
import voltoGdprPrivacy from 'volto-gdpr-privacy';

const addonsInfo = [{"name":"volto-dropdownmenu","version":"2.4.2","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-dropdownmenu/src","packageJson":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-dropdownmenu/package.json","addons":[]},{"name":"volto-venue","version":"3.2.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-venue/src","packageJson":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-venue/package.json","addons":[]},{"name":"volto-gdpr-privacy","version":"1.3.11","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-gdpr-privacy/src","packageJson":"/opt/www.comune.re.it/rosebud.voltotheme/node_modules/volto-gdpr-privacy/package.json","addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const projectConfig = (config) => {
  return typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [voltoDropdownmenu, voltoVenue, voltoGdprPrivacy];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
